import React from "react";
import PropTypes from "prop-types";

const SelectCustom = ({ options, value, onChange, disabled }) => (
  <select
    value={value}
    onChange={onChange}
    disabled={disabled}
    className={`text-xs py-0 px-1 border-gray-300 focus:border-secondary focus:ring-0 ${
      disabled ? "cursor-not-allowed" : ""
    }`}
  >
    <option value="">Select...</option>
    {options.map((option) => (
      <option key={option.value} value={option.value} className="hover:bg-secondary">
        {option.label}
      </option>
    ))}
  </select>
);

SelectCustom.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

SelectCustom.defaultProps = {
  options: [],
  value: "",
  onChange: () => {},
  disabled: false
};

export default SelectCustom;
